module.exports = __webpack_public_path__ + "img/resources-blog.033d6f6e.png";